// NClean reporting vocabulary. Authored text, identifiers and source records stay literal.
export const reportingMessages = {
  "Reusable data for your widgets, dashboards and report templates.": [
    "Uudelleenkäytettävää dataa widgeteihin, koontinäyttöihin ja raporttipohjiin.",
    "Данные для ваших виджетов, панелей и шаблонов отчётов.",
    "Дані для ваших віджетів, панелей і шаблонів звітів.",
  ],
  "Powers widgets": [
    "Widgetien tiedot",
    "Данные для виджетов",
    "Дані для віджетів",
  ],
  "No widgets connected yet": [
    "Ei vielä yhdistettyjä widgetejä",
    "Виджеты пока не подключены",
    "Віджети ще не підключені",
  ],
  "Not used in a dashboard yet": [
    "Ei vielä käytössä koontinäytöissä",
    "Пока не используется на панелях",
    "Ще не використовується на панелях",
  ],
  "Not used in a report template yet": [
    "Ei vielä käytössä raporttipohjissa",
    "Пока не используется в шаблонах отчётов",
    "Ще не використовується в шаблонах звітів",
  ],
  "Start guided setup?": [
    "Aloitetaanko ohjattu määritys?",
    "Начать настройку с подсказками?",
    "Почати кероване налаштування?",
  ],
  "Start guided setup": [
    "Aloita ohjattu määritys",
    "Начать настройку с подсказками",
    "Почати кероване налаштування",
  ],
  "This replaces your source query with a new guided configuration. Your saved binding is unchanged until you save.":
    [
      "Tämä korvaa lähdekyselysi uudella ohjatulla määrityksellä. Tallennettu datasidonta muuttuu vasta tallentaessasi.",
      "Исходный запрос будет заменён новой настройкой с подсказками. Сохранённая привязка изменится только после сохранения.",
      "Вихідний запит буде замінено новим керованим налаштуванням. Збережена прив’язка зміниться лише після збереження.",
    ],
  "Back to Data bindings": [
    "Takaisin datasidontoihin",
    "Назад к привязкам данных",
    "Назад до прив’язок даних",
  ],
  "Query mode": ["Kyselytila", "Режим запроса", "Режим запиту"],
  "Guided query": ["Ohjattu kysely", "Управляемый запрос", "Керований запит"],
  None: ["Ei mitään", "Нет", "Немає"],
  "Used in": ["Käytössä", "Используется в", "Використовується в"],
  "Not connected": ["Ei yhdistetty", "Не подключено", "Не підключено"],
  "Billing matrix": ["Laskutusmatriisi", "Матрица счетов", "Матриця рахунків"],
  "Value format": ["Arvon muoto", "Формат значения", "Формат значення"],
  "Display fields": [
    "Näytettävät kentät",
    "Отображаемые поля",
    "Поля відображення",
  ],
  "All result columns": [
    "Kaikki tulossarakkeet",
    "Все столбцы результата",
    "Усі стовпці результату",
  ],
  Target: ["Tavoite", "Цель", "Ціль"],
  "Widget inputs": ["Widgetin syötteet", "Входы виджета", "Входи віджета"],
  Optional: ["Valinnainen", "Необязательный", "Необов’язковий"],
  Required: ["Pakollinen", "Обязательный", "Обов’язковий"],
  percent: ["Prosentti", "Процент", "Відсоток"],
  ratio: ["Suhde", "Соотношение", "Співвідношення"],
  currency: ["Valuutta", "Валюта", "Валюта"],
  minutes: ["Minuutit", "Минуты", "Хвилини"],
  hours: ["Tunnit", "Часы", "Години"],
  "Recorded billing quantity": [
    "Kirjattu laskutusmäärä",
    "Учтённое количество для оплаты",
    "Облікована кількість для оплати",
  ],
  "Daily quantities": [
    "Päivittäiset määrät",
    "Ежедневные количества",
    "Щоденні кількості",
  ],
  "Billing summary": [
    "Laskutusyhteenveto",
    "Сводка счетов",
    "Підсумок рахунків",
  ],
  "Complete unit service matrix": [
    "Täydellinen yksikköpalvelumatriisi",
    "Полная матрица услуг по объектам",
    "Повна матриця послуг за об’єктами",
  ],
  "Allowance hours by company": [
    "Lisätunnit yhtiöittäin",
    "Дополнительные часы по компаниям",
    "Додаткові години за компаніями",
  ],
  "Pack quantities by company": [
    "Pakkausmäärät yhtiöittäin",
    "Количество комплектов по компаниям",
    "Кількість комплектів за компаніями",
  ],
  "Dated team work": [
    "Päivätty tiimityö",
    "Работа команды по дате",
    "Робота команди за датою",
  ],
  "Dated daily instruction": [
    "Päivätty päiväohje",
    "Инструкция на дату",
    "Інструкція на дату",
  ],
  "Dated standard reference": [
    "Päivätty standardiviite",
    "Нормативы на дату",
    "Нормативи на дату",
  ],
  "Held register entries": [
    "Säilytettävät rekisterimerkinnät",
    "Записи о хранящихся вещах",
    "Записи про речі на зберіганні",
  ],
  "Held entries at checkpoint": [
    "Säilytettävät merkinnät tarkistushetkellä",
    "Хранящиеся вещи на контрольную дату",
    "Речі на зберіганні на контрольну дату",
  ],
  "Batch membership": ["Erän sisältö", "Состав партии", "Склад партії"],
  "Batch header and recipient": [
    "Erän otsikko ja vastaanottaja",
    "Заголовок партии и получатель",
    "Заголовок партії та отримувач",
  ],

  "Back to Widgets": [
    "Takaisin widgeteihin",
    "Назад к виджетам",
    "Назад до віджетів",
  ],
  "Binding details": [
    "Sidonnan tiedot",
    "Сведения о привязке",
    "Відомості про прив’язку",
  ],
  "Binding name": ["Sidonnan nimi", "Название привязки", "Назва прив’язки"],
  "Name this shared data binding.": [
    "Anna tälle yhteiselle datasidonnalle nimi.",
    "Назовите эту общую привязку данных.",
    "Назвіть цю спільну прив’язку даних.",
  ],
  "Settings changed. Preview the query to refresh these results.": [
    "Asetukset muuttuivat. Päivitä tulokset esikatselemalla kyselyä.",
    "Настройки изменены. Обновите результаты предпросмотром запроса.",
    "Налаштування змінено. Оновіть результати попереднім переглядом запиту.",
  ],
  "Choose values, then preview the query.": [
    "Valitse arvot ja esikatsele kyselyä.",
    "Выберите значения и выполните предпросмотр запроса.",
    "Виберіть значення й виконайте попередній перегляд запиту.",
  ],
  "Text columns": ["Tekstisarakkeet", "Столбцы текста", "Стовпці тексту"],
  "Source dates shown in each view": [
    "Lähdepäivät näkyvät kussakin näkymässä",
    "Даты источников указаны в каждом представлении",
    "Дати джерел зазначені в кожному поданні",
  ],
  "May and October 2026 source examples": [
    "Lähde-esimerkit touko- ja lokakuulta 2026",
    "Примеры за май и октябрь 2026",
    "Приклади за травень і жовтень 2026",
  ],
  "Not found": ["Ei löytynyt", "Не найдено", "Не знайдено"],
  "Untitled data binding": [
    "Nimetön datasidonta",
    "Привязка данных без названия",
    "Прив’язка даних без назви",
  ],
  "Restore examples": [
    "Palauta esimerkit",
    "Восстановить примеры",
    "Відновити приклади",
  ],
  Dismiss: ["Sulje", "Закрыть", "Закрити"],
  "Loading…": ["Ladataan…", "Загрузка…", "Завантаження…"],
  "Widgets connected to current data. Source and refresh times are shown separately.":
    [
      "Widgetit käyttävät nykyisiä tietoja. Lähde- ja päivitysajat näytetään erikseen.",
      "Виджеты используют текущие данные. Время источника и обновления указано отдельно.",
      "Віджети використовують поточні дані. Час джерела й оновлення зазначено окремо.",
    ],
  "Delete dashboard": [
    "Poista koontinäyttö",
    "Удалить панель",
    "Видалити панель",
  ],
  Widgets: ["Widgetit", "Виджеты", "Віджети"],
  "Source as of": [
    "Lähdetiedot ajalta",
    "Данные источника на",
    "Дані джерела станом на",
  ],
  "Reusable typed inputs and visualizations. Data queries are configured separately.":
    [
      "Uudelleenkäytettävät tyypitetyt syötteet ja esitykset. Datakyselyt määritetään erikseen.",
      "Повторно используемые типизированные входы и визуализации. Запросы настраиваются отдельно.",
      "Повторно використовувані типізовані входи й візуалізації. Запити налаштовуються окремо.",
    ],
  "New data binding": [
    "Uusi datasidonta",
    "Новая привязка данных",
    "Нова прив’язка даних",
  ],
  "Untitled Widget": [
    "Nimetön widget",
    "Виджет без названия",
    "Віджет без назви",
  ],
  "New Widget": ["Uusi widget", "Новый виджет", "Новий віджет"],
  "Delete Widget": ["Poista widget", "Удалить виджет", "Видалити віджет"],
  Uses: ["Käyttökohteet", "Использования", "Використання"],
  Revision: ["Versio", "Версия", "Версія"],
  "Edit Widget": ["Muokkaa widgetiä", "Изменить виджет", "Змінити віджет"],
  Duplicate: ["Monista", "Дублировать", "Дублювати"],
  "Data bindings": ["Datasidonnat", "Привязки данных", "Прив’язки даних"],
  "Queries and input mappings shared by Dashboards and Report Templates.": [
    "Koontinäyttöjen ja raporttipohjien yhteiset kyselyt ja syötekytkennät.",
    "Общие запросы и сопоставления входов для панелей и шаблонов отчётов.",
    "Спільні запити й зіставлення входів для панелей і шаблонів звітів.",
  ],
  "Report Templates": ["Raporttipohjat", "Шаблоны отчётов", "Шаблони звітів"],
  "Compose text, conditional sections, Widgets and data queries into repeatable documents.":
    [
      "Yhdistä tekstiä, ehdollisia osia, widgetejä ja datakyselyjä toistettaviksi asiakirjoiksi.",
      "Объединяйте текст, условные разделы, виджеты и запросы в воспроизводимые документы.",
      "Поєднуйте текст, умовні розділи, віджети й запити у відтворювані документи.",
    ],
  "Untitled Report Template": [
    "Nimetön raporttipohja",
    "Шаблон отчёта без названия",
    "Шаблон звіту без назви",
  ],
  "Text section": ["Tekstiosa", "Текстовый раздел", "Текстовий розділ"],
  "New Report Template": [
    "Uusi raporttipohja",
    "Новый шаблон отчёта",
    "Новий шаблон звіту",
  ],
  "Delete Report Template": [
    "Poista raporttipohja",
    "Удалить шаблон отчёта",
    "Видалити шаблон звіту",
  ],
  Sections: ["Osat", "Разделы", "Розділи"],
  "Generate Report": ["Luo raportti", "Сформировать отчёт", "Сформувати звіт"],
  "Edit template": ["Muokkaa pohjaa", "Изменить шаблон", "Змінити шаблон"],
  "Saved document snapshots. Changes to templates, Widgets or source data do not change these Reports.":
    [
      "Tallennetut asiakirjat. Pohjien, widgetien tai lähdetietojen muutokset eivät muuta näitä raportteja.",
      "Сохранённые снимки документов. Изменения шаблонов, виджетов и источников не меняют эти отчёты.",
      "Збережені знімки документів. Зміни шаблонів, віджетів і джерел не змінюють ці звіти.",
    ],
  "Generate from template": [
    "Luo raporttipohjasta",
    "Сформировать из шаблона",
    "Сформувати із шаблону",
  ],
  Generated: ["Luotu", "Сформирован", "Сформовано"],
  "Open Report": ["Avaa raportti", "Открыть отчёт", "Відкрити звіт"],
  "No generated Reports yet": [
    "Raportteja ei ole vielä luotu",
    "Сформированных отчётов пока нет",
    "Сформованих звітів поки немає",
  ],
  "Choose a Report Template and generate its first document snapshot.": [
    "Valitse raporttipohja ja luo ensimmäinen asiakirja.",
    "Выберите шаблон и сформируйте первый снимок документа.",
    "Виберіть шаблон і сформуйте перший знімок документа.",
  ],
  "View Report Templates": [
    "Näytä raporttipohjat",
    "Посмотреть шаблоны отчётов",
    "Переглянути шаблони звітів",
  ],
  "Print / Save PDF": [
    "Tulosta / tallenna PDF",
    "Печать / сохранить PDF",
    "Друк / зберегти PDF",
  ],
  "Widget is in use": [
    "Widget on käytössä",
    "Виджет используется",
    "Віджет використовується",
  ],
  reset: ["palauta", "сброс", "скидання"],
  "Delete definition": [
    "Poista määritelmä",
    "Удалить определение",
    "Видалити визначення",
  ],
  "Remove or replace this Widget in every listed definition before deleting it.":
    [
      "Poista tai korvaa widget kaikissa luetelluissa määritelmissä ennen sen poistamista.",
      "Перед удалением уберите или замените виджет во всех перечисленных определениях.",
      "Перед видаленням приберіть або замініть віджет у всіх перелічених визначеннях.",
    ],
  "Restore the NClean definitions. Generated Reports and the migration backup are retained.":
    [
      "Palauta NClean-määritelmät. Luodut raportit ja siirron varmuuskopio säilytetään.",
      "Восстановить определения NClean. Сформированные отчёты и резервная копия миграции сохранятся.",
      "Відновити визначення NClean. Сформовані звіти й резервна копія міграції збережуться.",
    ],
  "This removes the definition. Generated Reports remain unchanged.": [
    "Määritelmä poistetaan. Luodut raportit säilyvät ennallaan.",
    "Определение будет удалено. Сформированные отчёты останутся без изменений.",
    "Визначення буде видалено. Сформовані звіти залишаться без змін.",
  ],
  Delete: ["Poista", "Удалить", "Видалити"],
  "Search library": [
    "Hae kirjastosta",
    "Поиск в библиотеке",
    "Пошук у бібліотеці",
  ],
  "No matching definitions": [
    "Vastaavia määritelmiä ei ole",
    "Подходящие определения не найдены",
    "Відповідних визначень не знайдено",
  ],
  "Missing Widget": [
    "Widget puuttuu",
    "Виджет отсутствует",
    "Віджет відсутній",
  ],
  "Configure placement": [
    "Määritä sijoitus",
    "Настроить размещение",
    "Налаштувати розміщення",
  ],
  "Edit data binding": [
    "Muokkaa datasidontaa",
    "Изменить привязку данных",
    "Змінити прив’язку даних",
  ],
  "Move up": ["Siirrä ylös", "Переместить выше", "Перемістити вище"],
  "Move down": ["Siirrä alas", "Переместить ниже", "Перемістити нижче"],
  "Remove placement": [
    "Poista sijoitus",
    "Убрать размещение",
    "Прибрати розміщення",
  ],
  "Select an existing Widget and data binding.": [
    "Valitse olemassa oleva widget ja datasidonta.",
    "Выберите существующий виджет и привязку данных.",
    "Виберіть наявний віджет і прив’язку даних.",
  ],
  Name: ["Nimi", "Название", "Назва"],
  "Add Widget": ["Lisää widget", "Добавить виджет", "Додати віджет"],
  "Last refreshed": [
    "Viimeksi päivitetty",
    "Последнее обновление",
    "Останнє оновлення",
  ],
  "Auto-refresh every 60 seconds while visible": [
    "Päivittyy 60 sekunnin välein näkyvissä ollessaan",
    "Автообновление каждые 60 секунд в видимой вкладке",
    "Автооновлення кожні 60 секунд у видимій вкладці",
  ],
  "Add Widgets to build your Dashboard.": [
    "Rakenna koontinäyttö lisäämällä widgetejä.",
    "Добавьте виджеты на панель.",
    "Додайте віджети на панель.",
  ],
  "Choose a Widget, data binding and placement overrides.": [
    "Valitse widget, datasidonta ja sijoituskohtaiset asetukset.",
    "Выберите виджет, привязку данных и настройки размещения.",
    "Виберіть віджет, прив’язку даних і налаштування розміщення.",
  ],
  "The document captures these parameters, language and data. Later edits do not change it.":
    [
      "Asiakirjaan tallentuvat nämä parametrit, kieli ja tiedot. Myöhemmät muutokset eivät muuta sitä.",
      "Документ сохранит эти параметры, язык и данные. Последующие изменения его не изменят.",
      "Документ збереже ці параметри, мову й дані. Подальші зміни його не змінять.",
    ],
  "Generating…": ["Luodaan…", "Формирование…", "Формування…"],
  "Generate and save": [
    "Luo ja tallenna",
    "Сформировать и сохранить",
    "Сформувати й зберегти",
  ],
  Parameters: ["Parametrit", "Параметры", "Параметри"],
  "Parameter name": ["Parametrin nimi", "Имя параметра", "Ім’я параметра"],
  "Parameter label": [
    "Parametrin otsikko",
    "Подпись параметра",
    "Підпис параметра",
  ],
  "Parameter type": ["Parametrin tyyppi", "Тип параметра", "Тип параметра"],
  "Default value": ["Oletusarvo", "Значение по умолчанию", "Типове значення"],
  "Remove parameter": [
    "Poista parametri",
    "Удалить параметр",
    "Видалити параметр",
  ],
  Parameter: ["Parametri", "Параметр", "Параметр"],
  "Add parameter": ["Lisää parametri", "Добавить параметр", "Додати параметр"],
  "Input mapping": [
    "Syötekytkentä",
    "Сопоставление входов",
    "Зіставлення входів",
  ],
  "Map Widget input names to query result columns. Use $rows for a generic rows array.":
    [
      "Kytke widgetin syötteet kyselyn tulossarakkeisiin. Käytä $rows-arvoa yleiselle rivitaulukolle.",
      "Сопоставьте входы виджета со столбцами результата. Используйте $rows для массива строк.",
      "Зіставте входи віджета зі стовпцями результату. Використовуйте $rows для масиву рядків.",
    ],
  "Remove mapping": [
    "Poista kytkentä",
    "Удалить сопоставление",
    "Видалити зіставлення",
  ],
  "Input name": ["Syötteen nimi", "Имя входа", "Ім’я входу"],
  "Add mapping": [
    "Lisää kytkentä",
    "Добавить сопоставление",
    "Додати зіставлення",
  ],
  "Shared binding edits affect every listed use.": [
    "Yhteisen sidonnan muutokset vaikuttavat kaikkiin lueteltuihin käyttökohteisiin.",
    "Изменения общей привязки затрагивают все перечисленные использования.",
    "Зміни спільної прив’язки впливають на всі перелічені використання.",
  ],
  "No uses yet": [
    "Ei vielä käyttökohteita",
    "Пока не используется",
    "Поки не використовується",
  ],
  "Parameters and input mapping": [
    "Parametrit ja syötekytkentä",
    "Параметры и сопоставление входов",
    "Параметри й зіставлення входів",
  ],
  Back: ["Takaisin", "Назад", "Назад"],
  "Save Widget": ["Tallenna widget", "Сохранить виджет", "Зберегти віджет"],
  "Typed input signature": [
    "Tyypitetty syötemäärittely",
    "Типизированная сигнатура входов",
    "Типізована сигнатура входів",
  ],
  "Input type": ["Syötteen tyyppi", "Тип входа", "Тип входу"],
  Nullable: [
    "Sallii puuttuvan arvon",
    "Допускает пустое значение",
    "Допускає порожнє значення",
  ],
  "Remove input": ["Poista syöte", "Удалить вход", "Видалити вхід"],
  "Add input": ["Lisää syöte", "Добавить вход", "Додати вхід"],
  "Widget preview": [
    "Widgetin esikatselu",
    "Предпросмотр виджета",
    "Попередній перегляд віджета",
  ],
  "Preview data binding": [
    "Esikatselun datasidonta",
    "Привязка для предпросмотра",
    "Прив’язка для попереднього перегляду",
  ],
  "Preview data is separate from the Widget definition.": [
    "Esikatselun tiedot ovat erillään widgetin määritelmästä.",
    "Данные предпросмотра отделены от определения виджета.",
    "Дані попереднього перегляду відокремлені від визначення віджета.",
  ],
  Widget: ["Widget", "Виджет", "Віджет"],
  "Data binding": ["Datasidonta", "Привязка данных", "Прив’язка даних"],
  "Local title": [
    "Sijoituskohtainen otsikko",
    "Локальный заголовок",
    "Локальний заголовок",
  ],
  "Local description": [
    "Sijoituskohtainen kuvaus",
    "Локальное описание",
    "Локальний опис",
  ],
  "Placement presentation": [
    "Sijoituksen ulkoasu",
    "Оформление размещения",
    "Оформлення розміщення",
  ],
  "Reset to Widget defaults": [
    "Palauta widgetin oletukset",
    "Вернуть настройки виджета",
    "Повернути налаштування віджета",
  ],
  "Save placement": [
    "Tallenna sijoitus",
    "Сохранить размещение",
    "Зберегти розміщення",
  ],
  "Preview template": [
    "Esikatsele pohjaa",
    "Предпросмотр шаблона",
    "Попередній перегляд шаблону",
  ],
  "Save Report Template": [
    "Tallenna raporttipohja",
    "Сохранить шаблон отчёта",
    "Зберегти шаблон звіту",
  ],
  "Named data bindings": [
    "Nimetyt datasidonnat",
    "Именованные привязки данных",
    "Іменовані прив’язки даних",
  ],
  "Widget and condition bindings are included automatically. Add bindings used by text placeholders here.":
    [
      "Widgetien ja ehtojen sidonnat sisällytetään automaattisesti. Lisää tekstin paikkamerkkien sidonnat tähän.",
      "Привязки виджетов и условий включаются автоматически. Добавьте здесь привязки текстовых подстановок.",
      "Прив’язки віджетів і умов включаються автоматично. Додайте тут прив’язки текстових підстановок.",
    ],
  "Text placeholders: {{params.name}} or {{binding-id.field}}. Scalar placeholders require one result row.":
    [
      "Tekstin paikkamerkit: {{params.name}} tai {{binding-id.field}}. Skalaariarvo vaatii yhden tulosrivin.",
      "Подстановки текста: {{params.name}} или {{binding-id.field}}. Скалярная подстановка требует одну строку.",
      "Підстановки тексту: {{params.name}} або {{binding-id.field}}. Скалярна підстановка потребує один рядок.",
    ],
  text: ["teksti", "текст", "текст"],
  "Widget section": ["Widget-osa", "Раздел виджета", "Розділ віджета"],
  "Remove section": ["Poista osa", "Удалить раздел", "Видалити розділ"],
  "Section title": ["Osan otsikko", "Заголовок раздела", "Заголовок розділу"],
  Text: ["Teksti", "Текст", "Текст"],
  "Conditional visibility": [
    "Ehdollinen näkyvyys",
    "Условная видимость",
    "Умовна видимість",
  ],
  "Condition binding": [
    "Ehdon datasidonta",
    "Привязка условия",
    "Прив’язка умови",
  ],
  "Condition operator": [
    "Ehto-operaattori",
    "Оператор условия",
    "Оператор умови",
  ],
  "Condition field": ["Ehdon kenttä", "Поле условия", "Поле умови"],
  "Comparison type": ["Vertailun tyyppi", "Тип сравнения", "Тип порівняння"],
  "Comparison value": [
    "Vertailuarvo",
    "Значение сравнения",
    "Значення порівняння",
  ],
  "Add text section": [
    "Lisää tekstiosa",
    "Добавить текстовый раздел",
    "Додати текстовий розділ",
  ],
  "Add Widget section": [
    "Lisää widget-osa",
    "Добавить раздел виджета",
    "Додати розділ віджета",
  ],
  "Preparing preview…": [
    "Valmistellaan esikatselua…",
    "Подготовка предпросмотра…",
    "Підготовка попереднього перегляду…",
  ],
  Unreported: ["Ilmoittamatta", "Не сообщено", "Не повідомлено"],
  "No records": ["Ei tietueita", "Нет записей", "Немає записів"],
  "·": ["·", "·", "·"],
  "Reporting group": ["Raportointiryhmä", "Отчётная группа", "Звітна група"],
  "All reporting groups": [
    "Kaikki raportointiryhmät",
    "Все отчётные группы",
    "Усі звітні групи",
  ],
  "Export complete CSV": [
    "Vie koko CSV",
    "Экспорт полного CSV",
    "Експорт повного CSV",
  ],
  "Unreported cells are blank in CSV. Week 42 is treated as submitted; later weeks are unreported.":
    [
      "Ilmoittamattomat solut ovat CSV:ssä tyhjiä. Viikko 42 käsitellään toimitettuna; myöhempiä viikkoja ei ole ilmoitettu.",
      "Неотчётные ячейки в CSV пусты. Неделя 42 считается сданной; последующие недели не отчитаны.",
      "Неподані комірки в CSV порожні. Тиждень 42 вважається поданим; наступні тижні не подані.",
    ],
  "Property Unit service matrix": [
    "Asuntokohtainen palvelumatriisi",
    "Матрица услуг по объектам",
    "Матриця послуг за об’єктами",
  ],
  "Preview query": [
    "Esikatsele kyselyä",
    "Предпросмотр запроса",
    "Попередній перегляд запиту",
  ],
  "Save binding": [
    "Tallenna sidonta",
    "Сохранить привязку",
    "Зберегти прив’язку",
  ],
  "Binding preview": [
    "Sidonnan esikatselu",
    "Предпросмотр привязки",
    "Попередній перегляд прив’язки",
  ],
  "NClean units": ["NClean-asunnot", "Объекты NClean", "Об’єкти NClean"],
  "One stable source or sample record": [
    "Yksi pysyvällä tunnisteella varustettu lähde- tai esimerkkitietue",
    "Одна исходная или образцовая запись со стабильным идентификатором",
    "Один вихідний або зразковий запис зі сталим ідентифікатором",
  ],
  "Group name": ["Ryhmän nimi", "Название группы", "Назва групи"],
  Category: ["Luokka", "Категория", "Категорія"],
  Area: ["Alue", "Участок", "Ділянка"],
  Classification: ["Luokitus", "Классификация", "Класифікація"],
  "NClean billing": ["NClean-laskutus", "Расчёт NClean", "Розрахунок NClean"],
  "Service date": ["Palvelupäivä", "Дата услуги", "Дата послуги"],
  "Source column": ["Lähdesarake", "Исходный столбец", "Вихідний стовпець"],
  "Source heading": [
    "Lähdeotsikko",
    "Исходный заголовок",
    "Вихідний заголовок",
  ],
  Quantity: ["Määrä", "Количество", "Кількість"],
  Interim: ["Välisiivous", "Промежуточная уборка", "Проміжне прибирання"],
  "Pack4 factor": [
    "4× pakkauskerroin",
    "Коэффициент упаковок 4×",
    "Коефіцієнт пакувань 4×",
  ],
  "Pack2 factor": [
    "2× pakkauskerroin",
    "Коэффициент упаковок 2×",
    "Коефіцієнт пакувань 2×",
  ],
  Payer: ["Maksaja", "Плательщик", "Платник"],
  "Service marker": ["Palvelumerkintä", "Метка услуги", "Позначка послуги"],
  "Pack4 units": [
    "4× pakkausmäärä",
    "Количество упаковок 4×",
    "Кількість пакувань 4×",
  ],
  "Pack2 units": [
    "2× pakkausmäärä",
    "Количество упаковок 2×",
    "Кількість пакувань 2×",
  ],
  "NClean work logs": [
    "NClean-työpäiväkirjat",
    "Журналы работ NClean",
    "Журнали робіт NClean",
  ],
  Team: ["Tiimi", "Бригада", "Бригада"],
  "Cleaner 1": ["Siivooja 1", "Уборщик 1", "Прибиральник 1"],
  "Cleaner 2": ["Siivooja 2", "Уборщик 2", "Прибиральник 2"],
  Vap: ["VAP", "VAP", "VAP"],
  "Job start": ["Työn alku", "Начало работы", "Початок роботи"],
  "Job finish": ["Työn loppu", "Окончание работы", "Завершення роботи"],
  Notes: ["Huomiot", "Примечания", "Примітки"],
  "NClean standards": [
    "NClean-viiteajat",
    "Нормативы NClean",
    "Нормативи NClean",
  ],
  "Display order": [
    "Näyttöjärjestys",
    "Порядок отображения",
    "Порядок відображення",
  ],
  "Area group": ["Alueryhmä", "Группа участков", "Група ділянок"],
  Capacity: ["Majoituskapasiteetti", "Вместимость", "Місткість"],
  "Standard minutes": [
    "Viiteaika minuutteina",
    "Норматив, минуты",
    "Норматив, хвилини",
  ],
  "Effective from": ["Voimassa alkaen", "Действует с", "Діє з"],
  "NClean instructions": [
    "NClean-ohjeet",
    "Инструкции NClean",
    "Інструкції NClean",
  ],
  Instruction: ["Ohje", "Инструкция", "Інструкція"],
  "NClean lost entries": [
    "NClean-löytötavarat",
    "Записи о находках NClean",
    "Записи про знахідки NClean",
  ],
  Item: ["Tavara", "Предмет", "Предмет"],
  "Original item": [
    "Alkuperäinen tavarakuvaus",
    "Исходное описание предмета",
    "Вихідний опис предмета",
  ],
  Brand: ["Merkki", "Марка", "Марка"],
  Colour: ["Väri", "Цвет", "Колір"],
  "Other information": ["Muuta tietoa", "Другие сведения", "Інші відомості"],
  "Found location": ["Löytöpaikka", "Место находки", "Місце знахідки"],
  "Recorded handover date": [
    "Kirjattu luovutuspäivä",
    "Записанная дата передачи",
    "Записана дата передачі",
  ],
  "Found date": ["Löytöpäivä", "Дата находки", "Дата знахідки"],
  "Custody from": ["Säilytyksessä alkaen", "На хранении с", "На зберіганні з"],
  "Dispatch date": ["Lähetyspäivä", "Дата отправки", "Дата відправлення"],
  "Batch id": ["Erätunnus", "Номер партии", "Номер партії"],
  "NClean batches": [
    "NClean-luovutuserät",
    "Партии передачи NClean",
    "Партії передачі NClean",
  ],
  "Coverage from": ["Jakson alku", "Начало периода", "Початок періоду"],
  "Coverage to": ["Jakson loppu", "Конец периода", "Кінець періоду"],
  Preparer: ["Laatija", "Составитель", "Укладач"],
  Recipient: ["Vastaanottaja", "Получатель", "Одержувач"],
  "Delivery address": ["Toimitusosoite", "Адрес доставки", "Адреса доставки"],
  "Recipient contact": [
    "Vastaanottajan yhteystieto",
    "Контакт получателя",
    "Контакт одержувача",
  ],
  "Original period": [
    "Alkuperäinen jakso",
    "Исходный период",
    "Вихідний період",
  ],
  "Original week": [
    "Alkuperäinen viikko",
    "Исходная неделя",
    "Вихідний тиждень",
  ],
  "NClean billing quantities": [
    "NClean-laskutusmäärät",
    "Учтённые количества NClean",
    "Обліковані кількості NClean",
  ],
  "Source marks with an explicitly assumed paired-column payer split; quantities are not unique visits.":
    [
      "Lähdemerkinnät ja oletettu maksajajako sarakepareittain; määrät eivät ole yksittäisiä käyntejä.",
      "Исходные отметки с предполагаемым разделением плательщиков по паре столбцов; количества не означают уникальные посещения.",
      "Вихідні позначки з припущеним поділом платників за парою стовпців; кількості не означають унікальні відвідування.",
    ],
  "Recorded quantity": [
    "Kirjattu määrä",
    "Учтённое количество",
    "Облікована кількість",
  ],
  "Replenishment allowance": [
    "Täydennyksen laskennallinen aika",
    "Норматив на пополнение",
    "Норматив на поповнення",
  ],
  "4× packs": ["4× pakkaukset", "Упаковки 4×", "Пакування 4×"],
  "2× packs": ["2× pakkaukset", "Упаковки 2×", "Пакування 2×"],
  "NClean reporting units": [
    "NClean-raportointiasunnot",
    "Отчётные объекты NClean",
    "Звітні об’єкти NClean",
  ],
  "458 source units; reporting group membership follows verified summary formulas, including cross-sheet Golfpuisto.":
    [
      "458 lähdeasuntoa; ryhmäjäsenyydet perustuvat tarkistettuihin yhteenvetokaavoihin, myös taulukkorajojen yli Golfpuistossa.",
      "458 исходных объектов; группы соответствуют проверенным формулам, включая Golfpuisto на разных листах.",
      "458 вихідних об’єктів; групи відповідають перевіреним формулам, зокрема Golfpuisto на різних аркушах.",
    ],
  "NClean daily work logs": [
    "NClean-päiväkohtaiset työpäiväkirjat",
    "Дневные журналы NClean",
    "Денні журнали NClean",
  ],
  "Explicit synthetic logs using the supplied form structure; elapsed intervals include any interruptions.":
    [
      "Synteettiset työpäiväkirjat toimitetun lomakkeen rakenteella; aikavälit sisältävät keskeytykset.",
      "Синтетические журналы по структуре исходной формы; интервалы включают перерывы.",
      "Синтетичні журнали за структурою вихідної форми; інтервали включають перерви.",
    ],
  "NClean duration standards": [
    "NClean-kestojen viitearvot",
    "Нормативы длительности NClean",
    "Нормативи тривалості NClean",
  ],
  "The 17 printed duration references; their labour/elapsed basis is not defined by the source.":
    [
      "17 painettua viiteaikaa; lähde ei määritä, kuvaavatko ne työmäärää vai kulunutta aikaa.",
      "17 печатных нормативов; источник не определяет их основу как трудозатраты или прошедшее время.",
      "17 друкованих нормативів; джерело не визначає їхню основу як трудовитрати чи минулий час.",
    ],
  "NClean daily instructions": [
    "NClean-päiväohjeet",
    "Ежедневные инструкции NClean",
    "Щоденні інструкції NClean",
  ],
  "NClean lost-property entries": [
    "NClean-löytötavaramerkinnät",
    "Записи о найденных вещах NClean",
    "Записи про знайдені речі NClean",
  ],
  "12 register entries; found dates unknown.": [
    "12 rekisterimerkintää; löytöpäivät tuntemattomia.",
    "12 записей; даты находки неизвестны.",
    "12 записів; дати знахідки невідомі.",
  ],
  "Register entries": [
    "Rekisterimerkinnät",
    "Записи реестра",
    "Записи реєстру",
  ],
  "NClean handover batches": [
    "NClean-luovutuserät",
    "Партии передачи NClean",
    "Партії передачі NClean",
  ],
  "A numeric input rendered as a KPI.": [
    "Numeerinen syöte esitettynä tunnuslukuna.",
    "Числовой вход в виде показателя.",
    "Числовий вхід у вигляді показника.",
  ],
  "Daily recorded quantities": [
    "Päivittäiset kirjatut määrät",
    "Учтённые количества по дням",
    "Обліковані кількості за днями",
  ],
  "Company and category totals": [
    "Yhtiö- ja luokkakohtaiset summat",
    "Итоги по компаниям и категориям",
    "Підсумки за компаніями й категоріями",
  ],
  "Weekly paired columns. Blank future cells are unreported; week 42 is treated as submitted.":
    [
      "Viikoittaiset sarakeparit. Tulevien päivien tyhjät solut ovat ilmoittamatta; viikko 42 käsitellään toimitettuna.",
      "Парные столбцы по неделям. Будущие пустые ячейки не отчитаны; неделя 42 считается сданной.",
      "Парні стовпці за тижнями. Майбутні порожні комірки не подані; тиждень 42 вважається поданим.",
    ],
  "Replenishment allowances": [
    "Täydennyksen laskennalliset ajat",
    "Нормативы на пополнение",
    "Нормативи на поповнення",
  ],
  "Standard allowance in decimal hours; 0.3 hours equals 18 minutes.": [
    "Laskennallinen aika desimaalitunteina; 0,3 tuntia on 18 minuuttia.",
    "Норматив в десятичных часах; 0,3 часа — 18 минут.",
    "Норматив у десяткових годинах; 0,3 години — 18 хвилин.",
  ],
  "Bag-packing quantities": [
    "Pussipakkausten määrät",
    "Количество комплектов",
    "Кількість комплектів",
  ],
  "Separate 4× and 2× pack counts. An absent source rule remains unavailable.":
    [
      "Erilliset 4× ja 2× pakkausmäärät. Puuttuva lähdesääntö jää ilman arvoa.",
      "Отдельные количества упаковок 4× и 2×. При отсутствии исходного правила значение недоступно.",
      "Окремі кількості пакувань 4× і 2×. За відсутності вихідного правила значення недоступне.",
    ],
  "Daily work log": [
    "Päivän työpäiväkirja",
    "Дневной журнал работ",
    "Денний журнал робіт",
  ],
  "Standard cleaning durations": [
    "Siivouksen viiteajat",
    "Нормативы времени уборки",
    "Нормативи часу прибирання",
  ],
  "Lost-property register": [
    "Löytötavararekisteri",
    "Реестр найденных вещей",
    "Реєстр знайдених речей",
  ],
  "Handover items": [
    "Luovutettavat tavarat",
    "Передаваемые вещи",
    "Речі для передачі",
  ],
  "NClean Client Verification": [
    "NClean-asiakastarkistus",
    "Проверка для клиента NClean",
    "Перевірка для клієнта NClean",
  ],
  "Review recorded quantities, allowances and packing by reporting company.": [
    "Tarkista määrät, laskennalliset ajat ja pakkaukset raportointiyhtiöittäin.",
    "Проверяйте количества, нормативы и комплекты по отчётным компаниям.",
    "Перевіряйте кількості, нормативи й комплекти за звітними компаніями.",
  ],
  "NClean Daily Operations": [
    "NClean-päivittäistoiminta",
    "Ежедневные операции NClean",
    "Щоденні операції NClean",
  ],
  "Dated cleaner and team records with explanations and reference standards.": [
    "Päivätyt siivoojien ja tiimien kirjaukset selityksineen ja viiteaikoineen.",
    "Датированные записи уборщиков и бригад с пояснениями и нормативами.",
    "Датовані записи прибиральників і бригад із поясненнями й нормативами.",
  ],
  "NClean Lost Property": [
    "NClean-löytötavarat",
    "Найденные вещи NClean",
    "Знайдені речі NClean",
  ],
  "Entries held at the selected checkpoint and explicit handover batches.": [
    "Valittuna ajankohtana säilytetyt tavarat ja määritetyt luovutuserät.",
    "Записи на хранении на выбранную дату и определённые партии передачи.",
    "Записи на зберіганні на вибрану дату й визначені партії передачі.",
  ],
  "Client Cleaning and Billing Verification": [
    "Asiakkaan siivous- ja laskutustarkistus",
    "Проверка уборки и расчётов для клиента",
    "Перевірка прибирання й розрахунків для клієнта",
  ],
  "Recorded services and source-based allowances for client review.": [
    "Kirjatut palvelut ja lähteeseen perustuvat laskennalliset ajat asiakkaan tarkistukseen.",
    "Учтённые услуги и исходные нормативы для проверки клиентом.",
    "Обліковані послуги й вихідні нормативи для перевірки клієнтом.",
  ],
  "Daily Cleaner or Team Work Log": [
    "Siivoojan tai tiimin päiväkirja",
    "Дневной журнал уборщика или бригады",
    "Денний журнал прибиральника або бригади",
  ],
  "Dated work, explanations and the printed duration reference.": [
    "Päivätyt työt, selitykset ja painetut viiteajat.",
    "Датированные работы, пояснения и печатные нормативы времени.",
    "Датовані роботи, пояснення й друковані нормативи часу.",
  ],
  "Lost-Property Register Snapshot": [
    "Löytötavararekisterin tilannekuva",
    "Снимок реестра найденных вещей",
    "Знімок реєстру знайдених речей",
  ],
  "A fixed custody register for a selected checkpoint.": [
    "Tallennettu säilytysrekisteri valitulta ajankohdalta.",
    "Зафиксированный реестр хранения на выбранную дату.",
    "Зафіксований реєстр зберігання на вибрану дату.",
  ],
  "Lost-Property Handover": [
    "Löytötavaroiden luovutus",
    "Передача найденных вещей",
    "Передача знайдених речей",
  ],
  "The selected handover batch and six-column recipient form.": [
    "Valittu luovutuserä ja kuusisarakkeinen vastaanottajalomake.",
    "Выбранная партия передачи и форма получателя из шести столбцов.",
    "Вибрана партія передачі й форма одержувача із шести стовпців.",
  ],
  "Cleaner or team": [
    "Siivooja tai tiimi",
    "Уборщик или бригада",
    "Прибиральник або бригада",
  ],
  "Snapshot date": ["Tilannekuvan päivä", "Дата снимка", "Дата знімка"],
  "Handover batch": ["Luovutuserä", "Партия передачи", "Партія передачі"],
  "Report period": ["Raportointijakso", "Период отчёта", "Період звіту"],
  "HCR Katinkulta · {{params.from}} – {{params.to}}": [
    "HCR Katinkulta · {{params.from}} – {{params.to}}",
    "HCR Katinkulta · {{params.from}} – {{params.to}}",
    "HCR Katinkulta · {{params.from}} – {{params.to}}",
  ],
  "Recorded quantities": [
    "Kirjatut määrät",
    "Учтённые количества",
    "Обліковані кількості",
  ],
  "Work date and team": [
    "Työpäivä ja tiimi",
    "Дата работы и бригада",
    "Дата роботи й бригада",
  ],
  "HCR Katinkulta · {{params.work_date}} · {{params.team}}": [
    "HCR Katinkulta · {{params.work_date}} · {{params.team}}",
    "HCR Katinkulta · {{params.work_date}} · {{params.team}}",
    "HCR Katinkulta · {{params.work_date}} · {{params.team}}",
  ],
  "Daily instruction": [
    "Päivän ohje",
    "Инструкция на день",
    "Інструкція на день",
  ],
  "{{instruction.instruction}}": [
    "{{instruction.instruction}}",
    "{{instruction.instruction}}",
    "{{instruction.instruction}}",
  ],
  "No recorded work": [
    "Ei kirjattua työtä",
    "Нет записанных работ",
    "Немає записаних робіт",
  ],
  "No work records match this date and team.": [
    "Tälle päivälle ja tiimille ei ole kirjauksia.",
    "Нет записей для этой даты и бригады.",
    "Немає записів для цієї дати й бригади.",
  ],
  "HCR Katinkulta · {{params.snapshot}}": [
    "HCR Katinkulta · {{params.snapshot}}",
    "HCR Katinkulta · {{params.snapshot}}",
    "HCR Katinkulta · {{params.snapshot}}",
  ],
  "Batch and recipient": [
    "Erä ja vastaanottaja",
    "Партия и получатель",
    "Партія й одержувач",
  ],
  "{{batch-header.property_name}} · {{batch-header.id}}\n{{batch-header.coverage_from}} – {{batch-header.coverage_to}}\nPrepared by {{batch-header.preparer}} · Dispatch {{batch-header.dispatch_date}}\n{{batch-header.recipient}}\n{{batch-header.delivery_address}}\n{{batch-header.recipient_contact}}":
    [
      "{{batch-header.property_name}} · {{batch-header.id}}\n{{batch-header.coverage_from}} – {{batch-header.coverage_to}}\nLaatija {{batch-header.preparer}} · Lähetys {{batch-header.dispatch_date}}\n{{batch-header.recipient}}\n{{batch-header.delivery_address}}\n{{batch-header.recipient_contact}}",
      "{{batch-header.property_name}} · {{batch-header.id}}\n{{batch-header.coverage_from}} – {{batch-header.coverage_to}}\nСоставитель {{batch-header.preparer}} · Отправка {{batch-header.dispatch_date}}\n{{batch-header.recipient}}\n{{batch-header.delivery_address}}\n{{batch-header.recipient_contact}}",
      "{{batch-header.property_name}} · {{batch-header.id}}\n{{batch-header.coverage_from}} – {{batch-header.coverage_to}}\nУкладач {{batch-header.preparer}} · Відправлення {{batch-header.dispatch_date}}\n{{batch-header.recipient}}\n{{batch-header.delivery_address}}\n{{batch-header.recipient_contact}}",
    ],
  "No handover batch": [
    "Ei luovutuserää",
    "Партия передачи отсутствует",
    "Партія передачі відсутня",
  ],
  "No handover batch matches this reference.": [
    "Tällä tunnuksella ei ole luovutuserää.",
    "Партия передачи с таким номером не найдена.",
    "Партію передачі з таким номером не знайдено.",
  ],
  string: ["teksti", "строка", "рядок"],
  date: ["päivä", "дата", "дата"],
  number: ["luku", "число", "число"],
  boolean: ["totuusarvo", "логический", "логічний"],
  timestamp: ["aikaleima", "дата и время", "дата й час"],
  array: ["taulukko", "массив", "масив"],
  record: ["tietue", "запись", "запис"],
  fifth: ["Viidesosa", "Пятая часть", "П’ята частина"],
  third: ["Kolmasosa", "Треть", "Третина"],
  half: ["Puolikas", "Половина", "Половина"],
  full: ["Koko leveys", "Полная ширина", "Повна ширина"],
  hasRows: ["Sisältää rivejä", "Есть строки", "Є рядки"],
  noRows: ["Ei rivejä", "Нет строк", "Немає рядків"],
  eq: ["Yhtä suuri", "Равно", "Дорівнює"],
  ne: ["Eri suuri", "Не равно", "Не дорівнює"],
  gt: ["Suurempi", "Больше", "Більше"],
  gte: ["Vähintään", "Не меньше", "Не менше"],
  lt: ["Pienempi", "Меньше", "Менше"],
  lte: ["Enintään", "Не больше", "Не більше"],
  isNull: ["Puuttuva arvo", "Пустое значение", "Порожнє значення"],
  notNull: ["Arvo on annettu", "Значение задано", "Значення задано"],
  "Data binding saved.": [
    "Datasidonta tallennettu.",
    "Привязка данных сохранена.",
    "Прив’язку даних збережено.",
  ],
  "Widget saved.": [
    "Widget tallennettu.",
    "Виджет сохранён.",
    "Віджет збережено.",
  ],
  "Report Template saved.": [
    "Raporttipohja tallennettu.",
    "Шаблон отчёта сохранён.",
    "Шаблон звіту збережено.",
  ],
  "Report generated and saved.": [
    "Raportti luotu ja tallennettu.",
    "Отчёт сформирован и сохранён.",
    "Звіт сформовано й збережено.",
  ],
  "Changes saved.": [
    "Muutokset tallennettu.",
    "Изменения сохранены.",
    "Зміни збережено.",
  ],
  "Property company": [
    "Kiinteistöyhtiö",
    "Компания недвижимости",
    "Компанія нерухомості",
  ],
  "HCR Rentals": ["HCR Rentals", "HCR Rentals", "HCR Rentals"],
  "Property Unit": ["Asunto", "Объект", "Об’єкт"],
  "Today, vacuum the air-conditioning filter screens in every house.": [
    "Tänään imuroidaan ilmastoinnin suodatinverkot jokaisessa asunnossa.",
    "Сегодня пылесосим сетки кондиционеров в каждом доме.",
    "Сьогодні пилососимо сітки кондиціонерів у кожному будинку.",
  ],
  "Today, clean the drains and shower wall and floor tiles, removing the pink residue.":
    [
      "Tänään puhdistetaan viemärit sekä suihkun seinä- ja lattialaatat vaaleanpunaisesta kertymästä.",
      "Сегодня моем водосливы и плитку в душевых на стенах и полу, удаляя розовый налёт.",
      "Сьогодні миємо водозливи й плитку в душових на стінах і підлозі, видаляючи рожевий наліт.",
    ],
} as const satisfies Record<string, readonly [string, string, string]>;
